import * as actionDefinitions from './actionDefinitions';
import { UpdateEntryPayload } from './types';

export const createTimesheetEntryRequest = (data: any) => ({ type: actionDefinitions.CREATE_TIMESHEET_ENTRY_REQUEST, data });
export const createTimesheetEntryRequestFailure = (error: any) => ({
  type: actionDefinitions.CREATE_TIMESHEET_ENTRY_REQUEST_FAILURE,
  error,
});
export const createTimesheetEntryRequestFinally = (data: any) => ({ type: actionDefinitions.CREATE_TIMESHEET_ENTRY_REQUEST_FINALLY, data });
export const createTimesheetEntryRequestSuccess = (data: any) => ({ type: actionDefinitions.CREATE_TIMESHEET_ENTRY_REQUEST_SUCCESS, data });

export const createEntryAndAssignClusterRequest = (data: any) => ({
  type: actionDefinitions.CREATE_ENTRY_AND_ASSIGN_CLUSTER_REQUEST,
  data,
});
export const createEntryAndAssignClusterRequestFailure = (error: any) => ({
  type: actionDefinitions.CREATE_ENTRY_AND_ASSIGN_CLUSTER_REQUEST_FAILURE,
  error,
});
export const createEntryAndAssignClusterRequestSuccess = (data: any) => ({
  type: actionDefinitions.CREATE_ENTRY_AND_ASSIGN_CLUSTER_REQUEST_SUCCESS,
  data,
});

export const createEntryAndAssignNodeRequest = (data: any) => ({
  type: actionDefinitions.CREATE_ENTRY_AND_ASSIGN_NODE_REQUEST,
  data,
});
export const createEntryAndAssignNodeRequestFailure = (error: any) => ({
  type: actionDefinitions.CREATE_ENTRY_AND_ASSIGN_NODE_REQUEST_FAILURE,
  error,
});
export const createEntryAndAssignNodeRequestSuccess = (data: any) => ({
  type: actionDefinitions.CREATE_ENTRY_AND_ASSIGN_NODE_REQUEST_SUCCESS,
  data,
});

export const deleteTimesheetEntryRequest = (data: any) => ({ type: actionDefinitions.DELETE_TIMESHEET_ENTRY_REQUEST, data });
export const deleteTimesheetEntryRequestFailure = (error: any) => ({
  type: actionDefinitions.DELETE_TIMESHEET_ENTRY_REQUEST_FAILURE,
  error,
});
export const deleteTimesheetEntryRequestSuccess = (data: any) => ({ type: actionDefinitions.DELETE_TIMESHEET_ENTRY_REQUEST_SUCCESS, data });

export const getTimesheetEntriesRequest = (data: any) => ({ type: actionDefinitions.GET_TIMESHEET_ENTRIES_REQUEST, data });
export const getTimesheetEntriesRequestFailure = (error: any) => ({ type: actionDefinitions.GET_TIMESHEET_ENTRIES_REQUEST_FAILURE, error });
export const getTimesheetEntriesRequestSuccess = (payload: { entryId: string }) => ({
  type: actionDefinitions.GET_TIMESHEET_ENTRIES_REQUEST_SUCCESS,
  payload,
});

export const resetTimesheetEntriesState = (data?: any) => ({ type: actionDefinitions.RESET_TIMESHEET_ENTRIES_STATE, data });

export const updateTimesheetEntryRequest = (data: UpdateEntryPayload) => ({ type: actionDefinitions.UPDATE_TIMESHEET_ENTRY_REQUEST, data });
export const updateTimesheetEntryRequestFailure = (error: any) => ({
  type: actionDefinitions.UPDATE_TIMESHEET_ENTRY_REQUEST_FAILURE,
  error,
});
export const updateTimesheetEntryRequestFinally = (data: any) => ({ type: actionDefinitions.UPDATE_TIMESHEET_ENTRY_REQUEST_FINALLY, data });
export const updateTimesheetEntryRequestSuccess = (data: any) => ({ type: actionDefinitions.UPDATE_TIMESHEET_ENTRY_REQUEST_SUCCESS, data });
